module.exports = __webpack_public_path__ + "media/media/product-card/item-3-9ce295fb1e30f0bebe79e67d9f4ba36e.png";